export default __webpack_public_path__ + "static/media/paciente.702db348.PNG";